// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import MobileOutlinedSvg from "@fishx/icons-svg/es/asn/MobileOutlined";
import FishxIcon from '../components/FishxIcon';

var MobileOutlined = function MobileOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: MobileOutlinedSvg
  }));
};

MobileOutlined.displayName = 'MobileOutlined';
export default React.forwardRef(MobileOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/MobileOutlined.js
// module id = 3156
// module chunks = 0